// components/ui/Section.jsx
import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export const Section = ({ 
  children, 
  title, 
  subtitle, 
  background = 'default',
  spacing = 6 
}) => {
  return (
    <Box
      sx={{
        background: background === 'gradient' 
          ? 'linear-gradient(135deg, #0a1128 0%, #1a1f3d 100%)'
          : 'transparent',
        py: spacing,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container>
        {(title || subtitle) && (
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            {title && (
              <Typography 
                variant="h2" 
                gutterBottom
                sx={{
                  background: 'linear-gradient(45deg, #ffffff, #ff4d4d)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography 
                variant="h6" 
                sx={{ 
                  color: 'rgba(255, 255, 255, 0.8)',
                  maxWidth: 600,
                  mx: 'auto',
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
      </Container>
    </Box>
  );
};

